// @flow

import { animate } from './animate';
import { easeInCubic } from './easings';
import { getOffsetTop } from './getOffsetTop';

export const scrollToElement = (
  node: HTMLElement,
  offset: number,
  options?: {| enforce?: boolean, smooth?: boolean |},
) => {
  const { enforce = false, smooth = true } = options ?? {};

  // const rect = node.getBoundingClientRect();
  const top = getOffsetTop(node);

  const isSmoothScrollSupported =
    // $FlowFixMe[incompatible-use]
    'scrollBehavior' in document.documentElement.style;

  const pos = top - offset;

  // Use enforce if you have to fight against a native scroll behavior
  // (e.g. mobile browsers scroll input to the middle of the screen on focus)
  if (enforce) {
    const set = () => window.scrollTo({ top: pos });
    set();
    setTimeout(set, 60);
    setTimeout(set, 120);
    setTimeout(set, 180);
    setTimeout(set, 240);
    setTimeout(set, 300);
  } else if (!smooth) {
    window.scrollTo({ top: pos });
  } else if (isSmoothScrollSupported) {
    // use browser smooth scroll if possible
    window.scrollTo({
      top: pos,
      behavior: 'smooth',
    });
  } else {
    animate({
      duration: 300,
      from: window.pageYOffset,
      to: pos,
      ease: easeInCubic,
      onStep: x => {
        window.scrollTo({ top: x });
      },
    });
  }
};
